<template>
  <o-section :level="level" :title="label || schema.verbose_name" not-closable>
    <o-repeating-cards
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      :list="items"
      display-order="display_order"
      @change="changed"
    >
      <template slot-scope="props">
        <item-form
          :form-state="formState"
          :item="items[props.index]"
          :level="level"
          :server-errors="_se[props.index]"
        ></item-form>
      </template>
    </o-repeating-cards>
  </o-section>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";

import OSection from "../../../vue-ocom/components/layout/OSection";
import ORepeatingCards from "../../../vue-ocom/components/table/ORepeatingCards";

import ItemForm from "./ItemForm";

export default {
  name: "DocumentTemplateSectionFormCards",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("DocumentTemplateSection"),
    CreateCodeTableFetchMixin(["FileSystem"]),
  ],
  components: { OSection, ORepeatingCards, ItemForm },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.DocumentTemplateSection,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.DocumentTemplateSection),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>
